/* CompuMac Leasing auf jeder Produktseite und im Warenkorb (02.10.2026).
   Inhaber: „das leasing soll für gewerbekunden immer und für alle geräte als option angeboten werden und auch online
   abschliessbar sein“, „the leasing options should be in all products in the store“ und (18:10) „leasing soll auch ohne
   kundenkonto sichtbar sein“ — der Kasten steht für jeden Besucher da, beschriftet „Für Unternehmen und Selbstständige“.

   snippets/cm-leasing-offer.liquid zeichnet den Kasten (Texte, Preis der gewählten Variante, Programme aus dem
   Steuerpult); dieses Skript rechnet die Rate dazu und setzt den Link:
   - Produktseite, Gerät: Rate für genau diese Variante und Stückzahl, Knopf in den Leasing-Konfigurator mit Gerät,
     Variante und Stückzahl vorgewählt (?geraet=&variante=&anzahl=).
   - Produktseite, Zubehör: keine eigene Rate (Inhaber 02.10.2026: „dazunehmen“) — das zeichnet das Snippet allein.
   - Warenkorb: Rate für alle Geräte des Warenkorbs, Zubehör als einmaliger Kauf daneben, Knopf zum Leasingantrag
     (/pages/leasing#konfiguration=…) — so lassen sich auch verschiedene Geräte in EINEM Antrag leasen.

   Die Rechnung ist die des Leasing-Konfigurators (assets/cm-finance-configurator.js, Funktionen us, ze, Qf und der
   Vorspann cmfRate/cmfMac75 — CompuHub scripts/_finance_configurator_build.ts) und seit 05.10.2026 die der Theke und
   der TARGO (Inhaber: „Website rechnet wie Theke/TARGO“; CompuHub lib/leasing.ts quoteFor), nichts Eigenes:
     Nettopreis = je Gerät Math.round(Apple Preis × 100 / 119) × Anzahl (der Betrag der Rechnung);
     Rate netto = Nettopreis × gedruckter Leasingfaktor, kaufmännisch auf den Cent (Leasing 85: 3,542 %, Mac 75: 3,125 %
     — die Zahlen stehen NUR im Steuerpult am Angebot und kommen über das Shop-Metafeld compuhub.leasing_plans,
     plans.<programm>.factors; ohne Faktor, wie bei 0 % Leasing: Anteil ÷ Laufzeit genau, also 85/24, 75/24, 100/24);
     alle Raten gleich; Summe der Raten = ungerundete Rate × Laufzeit (wie das Papier der Bank); brutto = netto × 1,19
     auf den Cent (netto = Math.round(brutto × 100 / 119) ergibt wieder genau die Netto-Rate).
     Leasing 85 und Mac 75 ab 1.785 € brutto (1.500 € netto) Warenwert inkl. Zubehör, Leasing 85 mit mindestens 80 %
     Geräteanteil; einmalig 75 € netto (89,25 € brutto) je Bestellung.
   Zubehör wird nie geleast: es wird einmalig gekauft und zählt zum Warenwert (wie im Konfigurator).
   Leasing 85 „so wie es bei TARGO steht“ (Inhaber 02.10.2026, 17:30 und 21:00): für die BEDINGUNG zählen nur die
   Produkttypen des Angebots im Steuerpult (Mac, iPhone, iPad — snippets/cm-leasing-types, je Gerät „l85“). Machen sie
   mindestens 80 % des Auftragswerts aus (und ist der Mindestwert erreicht), gilt Leasing 85 für den GANZEN Auftrag —
   auch eine Apple Watch, AirPods, Apple TV, ein Display, Home im Rest bekommen die 85 % („watch wird auch subvensioniert
   solange die andere anteile über 80% des netto auftragswert ausmachen“). So rechnet auch die Theke (CompuHub
   lib/leasing.ts, offersFor: ein Vertrag über die ganze Bestellung). Liegen Mac, iPhone, iPad unter 80 %, gibt es kein
   Leasing 85 (dann 0 %); nur Watches oder AirPods ohne Mac/iPhone/iPad: 0 %. 0 % Leasing gilt für jede Geräteart.
   Das beste Programm ist gewählt (Inhaber 21:00): nur Macs ab 1.500 € netto → Mac 75, sonst Leasing 85, sonst 0 %.
   CompuHub prüft diese Datei gegen den Vorspann (tests/leasing-alle-geraete.test.ts) — wer hier eine Zahl ändert,
   ändert Raten.

   Welche Programme es gibt, sagt das Steuerpult (Shop-Metafeld compuhub.leasing_plans, dieselbe Regel wie
   snippets/cm-leasing-plans und cmfPlanState: aus ist nur, was ausdrücklich on: false trägt). */
(() => {
  const SHARE = { leasing85: 0.85, mac75: 0.75, zero: 1 };
  const TERMS = { leasing85: [24], mac75: [24], zero: [24, 36] };
  const MIN_GROSS = 178500;
  const FEE = { gross: 8925, net: 7500 };
  /* Das Programm mit dem größten Vorteil zuerst. */
  const ORDER = ['mac75', 'leasing85', 'zero'];

  const net = (gross) => Math.round((gross * 100) / 119);
  /* Netto → brutto auf den Cent; net(gross(n)) === n für jeden Cent-Betrag n (der Fehler bleibt unter einem halben Cent). */
  const gross = (netCents) => Math.round((netCents * 119) / 100);
  /* Anzeige in der Sprache der Seite (05.10.2026, layout/theme.liquid CMMoney: DE „89,26 €“, EN „€89.26“); der Text des
     Leasingantrags (cartConfiguration) liest das Team und bleibt deutsch (euroDe). */
  const euroDe = (cents) => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  const euro = (cents) => (typeof window !== 'undefined' && window.CMMoney ? window.CMMoney.format(cents) : euroDe(cents));
  const pct = (plan) => Math.round((1 - SHARE[plan]) * 100);

  function planState(raw) {
    const plans = raw && typeof raw === 'object' && raw.v === 1 && raw.plans && typeof raw.plans === 'object' ? raw.plans : null;
    const out = {};
    Object.keys(TERMS).forEach((id) => {
      const all = TERMS[id];
      const p = plans && plans[id];
      if (p && typeof p === 'object' && p.on === false) {
        out[id] = { on: false, months: [] };
        return;
      }
      const months = p && typeof p === 'object' && Array.isArray(p.months) ? all.filter((m) => p.months.indexOf(m) >= 0) : [];
      out[id] = { on: true, months: months.length ? months : all.slice(), factors: factorsOf(p) };
    });
    return out;
  }

  /* Die gedruckten Leasingfaktoren je Laufzeit aus dem Steuerpult ({"24": <Faktor in %>}); nur Zahlen zwischen 0 und 100. */
  function factorsOf(p) {
    const out = {};
    const f = p && typeof p === 'object' && p.factors && typeof p.factors === 'object' ? p.factors : null;
    if (f) Object.keys(f).forEach((k) => {
      if (typeof f[k] === 'number' && isFinite(f[k]) && f[k] > 0 && f[k] < 100) out[k] = f[k];
    });
    return out;
  }

  /* Faktor in Prozent je Monat: der gedruckte aus dem Steuerpult, sonst genau Anteil ÷ Laufzeit (0 % Leasing druckt keinen). */
  function factorFor(plans, plan, months) {
    const f = plans && plans[plan] && plans[plan].factors ? plans[plan].factors[String(months)] : undefined;
    return typeof f === 'number' && isFinite(f) && f > 0 && f < 100 ? f : (SHARE[plan] * 100) / months;
  }

  /*
   * us() des Konfigurators (cmfRate im Vorspann), gerechnet wie CompuHub lib/leasing.ts quoteFor: Nettopreis × Faktor.
   * reference: Apple Preis brutto gesamt (Cent); netBase: Nettopreis gesamt (Cent, Summe der Einzelpreise netto × Anzahl —
   * fehlt er, netto des Gesamtpreises); factor: Prozent je Monat (fehlt er: Anteil ÷ Laufzeit).
   * Ergebnis in Cent: monthly/lastPayment/deviceTotal brutto (wie bisher, für Texte und den Antrag), dazu monthlyNet,
   * totalNet, netBase, factor. Bei 0 % Leasing ist die Summe genau der Apple Preis (kein Vorteil, kein Cent mehr).
   */
  function rate(reference, plan, months, netBase, factor) {
    if (!Number.isSafeInteger(reference) || reference <= 0) throw new Error('Ungültige Berechnung');
    if (!Object.prototype.hasOwnProperty.call(SHARE, plan) || [24, 36].indexOf(months) < 0 || (plan !== 'zero' && months !== 24)) throw new Error('Ungültige Laufzeit');
    const base = Number.isSafeInteger(netBase) && netBase > 0 ? netBase : net(reference);
    const f = typeof factor === 'number' && isFinite(factor) && factor > 0 && factor < 100 ? factor : (SHARE[plan] * 100) / months;
    /* Wie quoteFor: in Euro gerechnet, dann kaufmännisch auf den Cent. */
    const exact = (base / 100) * (f / 100);
    const monthlyNet = Math.round(exact * 100);
    const totalNet = plan === 'zero' ? base : Math.round(exact * months * 100);
    const monthly = gross(monthlyNet);
    const total = plan === 'zero' ? reference : gross(totalNet);
    return { reference, deviceTotal: total, difference: reference - total, monthly, lastPayment: monthly, monthlyNet, totalNet, netBase: base, factor: f };
  }

  /* Qf() des Konfigurators: Warenwert inkl. Zubehör, Geräteanteil. */
  function goods(deviceGross, accessoryGross) {
    const total = deviceGross + accessoryGross;
    return { eligible: total >= MIN_GROSS && deviceGross * 5 >= total * 4, goodsGross: total, missingGross: Math.max(0, MIN_GROSS - total), shareMet: deviceGross * 5 >= total * 4 };
  }

  /*
   * Welches Programm für diese Geräte gilt — das mit dem größten Vorteil, das die Regeln erfüllt.
   * input: { devices: [ { price (Cent brutto), qty, mac, l85 } ], accessoriesGross (Cent brutto, einmaliger Kauf) }
   *   l85: das Gerät zählt für die Bedingung von Leasing 85 (Produkttyp des Angebots); fehlt die Angabe, gilt true
   *   (Snippet von vor dem 02.10.2026). Ein Gerät mit l85: false zählt beim 80-%-Anteil zum Rest — gilt Leasing 85,
   *   bekommt es die 85 % wie alle Geräte des Auftrags.
   * Ergebnis: plan (null = keines), months, die Rate (wie us), netto-Werte, und `better`: das Programm mit Vorteil,
   * das noch nicht gilt, mit dem, was fehlt (missingGross, shareMet) — nur, wenn es für diese Geräte überhaupt eines gibt.
   * `otherGross`: der Apple Preis der Geräte im Auftrag, die nicht zur Bedingung zählen (für den Satz im Kasten).
   */
  function quote(input, plansRaw) {
    const plans = plansRaw && plansRaw.leasing85 && plansRaw.zero ? plansRaw : planState(plansRaw);
    const devices = (input && Array.isArray(input.devices) ? input.devices : []).filter((d) => d && Number.isSafeInteger(d.price) && d.price > 0 && Number.isSafeInteger(d.qty) && d.qty >= 1 && d.qty <= 999);
    const accessoriesGross = input && Number.isSafeInteger(input.accessoriesGross) && input.accessoriesGross > 0 ? input.accessoriesGross : 0;
    const reference = devices.reduce((sum, d) => sum + d.price * d.qty, 0);
    /* Nettopreis wie auf der Rechnung: je Gerät netto, mal Anzahl (CompuHub: netUnit × quantity). */
    const netBase = devices.reduce((sum, d) => sum + net(d.price) * d.qty, 0);
    if (!devices.length || !Number.isSafeInteger(reference)) return { plan: null, reason: 'no-device', reference: 0, accessoriesGross };
    /* Der Teil, für den Leasing 85 gilt — und der Rest, der beim Anteil auf der Seite des Zubehörs steht. */
    const benefitGross = devices.reduce((sum, d) => sum + (d.l85 !== false ? d.price * d.qty : 0), 0);
    const otherGross = reference - benefitGross;
    const g = goods(benefitGross, otherGross + accessoriesGross);
    const onlyMacs = devices.every((d) => d.mac === true);
    const mac75Fits = plans.mac75.on && onlyMacs && accessoriesGross === 0;
    const l85Fits = plans.leasing85.on && benefitGross > 0;
    const can = { mac75: mac75Fits && reference >= MIN_GROSS, leasing85: l85Fits && g.eligible, zero: plans.zero.on && plans.zero.months.length > 0 };
    const plan = ORDER.filter((id) => can[id])[0] || null;
    let better = null;
    if (plan !== 'mac75' && mac75Fits) better = { plan: 'mac75', missingGross: Math.max(0, MIN_GROSS - reference), shareMet: true };
    else if (plan !== 'mac75' && plan !== 'leasing85' && l85Fits) better = { plan: 'leasing85', missingGross: g.missingGross, shareMet: g.shareMet };
    if (!plan) return { plan: null, reason: 'rules', reference, accessoriesGross, better };
    const months = plan === 'zero' ? (plans.zero.months.indexOf(24) >= 0 ? 24 : plans.zero.months[0]) : 24;
    /* Ein Programm für den ganzen Auftrag: gilt Leasing 85, dann für jedes Gerät darin — auch für die im 20-%-Rest. */
    const r = rate(reference, plan, months, netBase, factorFor(plans, plan, months));
    const deviceTotal = r.deviceTotal;
    const monthly = r.monthly;
    const lastPayment = r.lastPayment;
    return {
      plan,
      months,
      percent: plan === 'zero' ? 0 : pct(plan),
      reference,
      accessoriesGross,
      benefitGross: plan === 'leasing85' ? benefitGross : plan === 'mac75' ? reference : 0,
      otherGross: plan === 'leasing85' ? otherGross : 0,
      deviceTotal,
      difference: r.difference,
      monthly,
      lastPayment,
      monthlyNet: r.monthlyNet,
      lastNet: r.monthlyNet,
      deviceNet: r.netBase,
      factor: r.factor,
      better,
    };
  }

  /* Wie cmfEncode im Konfigurator: Base64url-JSON für den Anker #konfiguration=… (geht nie an einen Server). */
  function encode(value) {
    const bytes = new TextEncoder().encode(JSON.stringify(value));
    let s = '';
    for (let i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
    return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  const PLAN_NAME = { leasing85: 'Leasing 85', mac75: 'Mac 75', zero: '0 % Leasing' };
  const PLAN_TEXT = { leasing85: 'Leasing 85 (15% Gerätepreisvorteil)', mac75: 'Mac 75 (25% Gerätepreisvorteil, nur Macs)', zero: '0% Leasing (ohne Gerätepreisnachlass)' };

  /*
   * Der Warenkorb als Konfiguration für den Leasingantrag — dieselbe Form wie die Übergabe des Konfigurators
   * (cm-finance-form.js decodeConfiguration; CompuHub lib/finance-requests/web.ts configurationFrom): Text mit einer
   * Gruppe „Modell: …“ je Gerät (so liest ihn auch die TARGO-Abbildung), Programm, Laufzeit, Rate netto, Gerätepreis netto.
   * lines: [ { title, variant, sku, qty, price, kind: "device" | "accessory" | "none", mac, l85 } ] — „none“ wird nicht geleast
   * und nicht mitgekauft (Gebrauchtes, Termine, Gutscheine) und steht deshalb nur als Hinweis im Text.
   */
  function cartConfiguration(lines, q) {
    if (!q || !q.plan) return null;
    const devices = lines.filter((l) => l.kind === 'device');
    const accessories = lines.filter((l) => l.kind === 'accessory');
    const left = lines.filter((l) => l.kind !== 'device' && l.kind !== 'accessory');
    const spec = (l) => (l.variant && !/^default title$/i.test(l.variant) ? l.variant : '');
    const build = (short) => {
      const out = ['LEASINGANTRAG – KONFIGURATION (aus dem Warenkorb)', 'Alle Preise brutto, inkl. 19% MwSt.', '', '1. GERÄTE'];
      devices.forEach((l) => {
        out.push(`Modell: ${l.title}`);
        if (spec(l)) out.push(`Ausstattung: ${spec(l)}`);
        if (l.sku) out.push(`Artikelnummer: ${l.sku}`);
        out.push(`Anzahl: ${l.qty} Stück`);
        if (!short) out.push(`Apple Preis pro Gerät: ${euroDe(l.price)}`);
        out.push(`Einzelpreis netto: ${euroDe(net(l.price))}`);
      });
      out.push(`Apple Gerätepreis gesamt: ${euroDe(q.reference)}`, '', '2. ZUBEHÖR');
      if (accessories.length) {
        out.push('Einmaliger Kauf, wird nicht geleast.');
        accessories.forEach((l) => out.push(`${l.qty} × ${l.title}${spec(l) ? ` (${spec(l)})` : ''}${l.sku ? ` · Art.-Nr. ${l.sku}` : ''} · ${short ? '' : `Einzelpreis ${euroDe(l.price)} · `}Gesamt ${euroDe(l.price * l.qty)}`));
        out.push(`Zubehör gesamt: ${euroDe(q.accessoriesGross)}`);
      } else out.push('Kein Zubehör im Warenkorb.');
      out.push(
        '',
        '3. LEASING',
        `Programm: ${PLAN_TEXT[q.plan]}`,
        ...(q.otherGross > 0 ? [`Bedingung erfüllt: ${euroDe(q.benefitGross)} von ${euroDe(q.reference + q.accessoriesGross)} Auftragswert sind Mac, iPhone oder iPad (mindestens 80%). Leasing 85 gilt für alle Geräte des Auftrags.`] : []),
        `Laufzeit: ${q.months} Monate`,
        'Zinsen: 0%',
        'Die folgenden Raten gelten für ALLE Geräte zusammen:',
        `${q.months} Raten à ${euroDe(q.monthly)} pro Monat (alle Raten gleich)`,
        `Gerätepreisvorteil gesamt: ${euroDe(q.difference)}`,
        '',
        '4. GESAMTKOSTEN',
        `Leasingraten für alle Geräte: ${euroDe(q.deviceTotal)}`,
        `Zubehör gesamt: ${euroDe(q.accessoriesGross)}`,
        `Bestellgebühr (1 × je Auftrag): ${euroDe(FEE.gross)}`,
        `GESAMT: ${euroDe(q.deviceTotal + q.accessoriesGross + FEE.gross)}`,
      );
      if (left.length) out.push('', 'NICHT IM LEASING (im Warenkorb, aber weder geleast noch mitgekauft)', ...left.map((l) => `${l.qty} × ${l.title}`));
      out.push('', 'BEARBEITUNG', 'Konfiguration zum Leasingantrag aus dem Warenkorb, noch keine Bestellung oder Reservierung.', 'Preise, Verfügbarkeit und Liefertermin prüfen.');
      return out.join('\n');
    };
    let text = build(false);
    if (text.length > 2900) text = build(true);
    /* CompuHub und das Formular nehmen 3.000 Zeichen; ein abgeschnittener Text wäre ein falscher Antrag. */
    if (text.length > 2900) return null;
    const count = devices.reduce((sum, l) => sum + l.qty, 0);
    const summaryLines = devices.map((l) => `${l.qty} × ${l.title}${spec(l) ? ` · ${spec(l)}` : ''}`);
    return {
      v: 1,
      source: 'iphone-leasing',
      plan: q.plan,
      months: q.months,
      text,
      monthlyNet: (q.monthlyNet / 100).toFixed(2),
      deviceNet: (q.deviceNet / 100).toFixed(2),
      summary: {
        /* model/quantity für ein älteres Formular-Skript, das „lines“ noch nicht kennt. */
        model: count === 1 ? devices[0].title : `Warenkorb mit ${count} Geräten`,
        quantity: count === 1 ? devices[0].qty : 1,
        storage: count === 1 ? spec(devices[0]) : '',
        color: '',
        lines: summaryLines,
        accessories: accessories.map((l) => `${l.qty} × ${l.title}`),
        accessoriesOnce: true,
        monthlyNetCents: q.monthlyNet,
        lastNetCents: q.lastNet,
        plan: PLAN_NAME[q.plan],
        months: q.months,
        note: null,
        wg: null,
        cart: true,
      },
    };
  }

  const core = { SHARE, MIN_GROSS, FEE, net, gross, euro, euroDe, pct, planState, factorFor, rate, goods, quote, encode, cartConfiguration };
  if (typeof window !== 'undefined') window.CMLeasing = core;
  if (typeof document === 'undefined') return;

  /* ------------------------------------------------------------------ Zeichnen */

  const fill = (text, values) => String(text || '').replace(/\[([a-z_]+)\]/g, (all, key) => (Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : all));
  const readJson = (node) => {
    try {
      return node ? JSON.parse(node.textContent || 'null') : null;
    } catch (error) {
      return null;
    }
  };
  /* Die Beschriftung des Knopfs steht in einem eigenen <span>, der Pfeil daneben bleibt. */
  const label = (link, text) => {
    const node = link && (link.querySelector('[data-cm-leasing-label]') || link);
    if (node && text) node.textContent = text;
  };
  const show = (node, text) => {
    if (!node) return;
    node.textContent = text || '';
    node.hidden = !text;
  };

  function values(q, t) {
    const out = {};
    if (!q) return out;
    if (q.plan) {
      out.rate = euro(q.monthlyNet);
      out.gross = euro(q.monthly);
      out.plan = PLAN_NAME[q.plan];
      out.months = q.months;
      out.percent = q.percent;
    }
    if (q.better) {
      out.better = PLAN_NAME[q.better.plan];
      out.better_percent = pct(q.better.plan);
      out.missing = euro(net(q.better.missingGross));
    }
    /* „Mac, iPhone und iPad“ — die Gerätearten von Leasing 85, wie das Snippet sie aus dem Steuerpult liest. */
    out.devices = (t && t.devices) || 'Mac, iPhone und iPad';
    return out;
  }

  /* Der Hinweis auf das Programm mit Vorteil, das noch nicht gilt. */
  function betterText(q, t, v) {
    if (!q || !q.better) return '';
    if (q.better.missingGross > 0) return fill(t.better_missing, v);
    return q.better.shareMet ? '' : fill(t.better_share, v);
  }

  function renderProduct(box) {
    const data = readJson(box.querySelector('[data-cm-leasing-data]')) || {};
    const t = data.t || {};
    const rateNode = box.querySelector('[data-cm-leasing-rate]');
    const lineNode = box.querySelector('[data-cm-leasing-line]');
    const hintNode = box.querySelector('[data-cm-leasing-hint]');
    const link = box.querySelector('[data-cm-leasing-link]');
    const scope = box.closest('product-info') || document;
    const input = scope.querySelector('.quantity__input');
    const qty = Math.min(999, Math.max(1, Math.floor(Number(input && input.value) || 1)));
    if (link && box.dataset.url) {
      const params = new URLSearchParams();
      if (box.dataset.handle) params.set('geraet', box.dataset.handle);
      if (/^\d+$/.test(box.dataset.variant || '')) params.set('variante', box.dataset.variant);
      if (qty > 1) params.set('anzahl', String(qty));
      const query = params.toString();
      link.setAttribute('href', box.dataset.url + (query ? (box.dataset.url.indexOf('?') < 0 ? '?' : '&') + query : ''));
    }
    /* Rate nur für Geräte (das Snippet setzt data-rate="true"); Zubehör bekommt keine eigene Rate. */
    if (box.dataset.rate !== 'true' || !rateNode) return;
    const price = Number(box.dataset.price);
    const q = quote({ devices: [{ price, qty, mac: box.dataset.mac === 'true', l85: box.dataset.l85 !== 'false' }], accessoriesGross: 0 }, data.plans);
    const v = values(q, t);
    v.count = qty;
    if (q.plan) {
      show(rateNode, fill(qty === 1 ? t.rate : t.rate_many, v));
      show(lineNode, fill(q.percent ? t.line_benefit : t.line_zero, v));
      show(hintNode, betterText(q, t, v));
    } else {
      show(rateNode, '');
      show(lineNode, q.better ? fill(t.none_missing, v) : t.none || '');
      show(hintNode, '');
    }
  }

  function renderCart(box) {
    const data = readJson(box.querySelector('[data-cm-leasing-data]')) || {};
    const t = data.t || {};
    const lines = (Array.isArray(data.lines) ? data.lines : []).filter((l) => l && Number.isSafeInteger(l.price) && Number.isSafeInteger(l.qty) && l.qty >= 1);
    const devices = lines.filter((l) => l.kind === 'device');
    const accessoriesGross = lines.filter((l) => l.kind === 'accessory').reduce((sum, l) => sum + l.price * l.qty, 0);
    const q = quote({ devices: devices.map((l) => ({ price: l.price, qty: l.qty, mac: l.mac === true, l85: l.l85 !== false })), accessoriesGross }, data.plans);
    const v = values(q, t);
    v.count = devices.reduce((sum, l) => sum + l.qty, 0);
    v.accessories = euro(net(accessoriesGross));
    const rateNode = box.querySelector('[data-cm-leasing-rate]');
    const lineNode = box.querySelector('[data-cm-leasing-line]');
    const hintNode = box.querySelector('[data-cm-leasing-hint]');
    const onceNode = box.querySelector('[data-cm-leasing-once]');
    const link = box.querySelector('[data-cm-leasing-link]');
    const fallbackUrl = box.dataset.url || '/pages/leasing-konfigurator';
    /* Schublade (04.10.2026, warenkorb-schlank): nur EINE Zeile „Für Unternehmen: Warenkorb leasen ab … netto/Monat →“
       mit dem Link zum Leasingantrag wie im Kasten. Ohne Rate führt sie zum Kasten auf der Warenkorbseite. */
    if (box.dataset.compact === 'true') {
      const conf = devices.length && q.plan ? cartConfiguration(lines, q) : null;
      if (!link) return;
      if (conf) {
        label(link, fill(t.drawer_rate, v));
        link.setAttribute('href', (box.dataset.formUrl || '/pages/leasing') + '#konfiguration=' + encode(conf));
      } else {
        label(link, t.drawer_static);
        link.setAttribute('href', box.dataset.cartUrl || '/cart');
      }
      return;
    }
    if (!devices.length) {
      show(rateNode, '');
      show(lineNode, t.cart_no_device || '');
      show(hintNode, '');
      show(onceNode, '');
      if (link) {
        label(link, t.cart_cta_configure);
        link.setAttribute('href', fallbackUrl);
      }
      return;
    }
    const configuration = cartConfiguration(lines, q);
    if (q.plan && configuration) {
      show(rateNode, fill(v.count === 1 ? t.rate : t.cart_rate, v));
      show(lineNode, fill(q.percent ? t.line_benefit : t.line_zero, v));
      /* Leasing 85 mit anderen Geräten im Warenkorb: sagen, warum es für alle gilt (80-%-Regel). */
      show(hintNode, q.otherGross > 0 ? fill(t.cart_mixed, v) : betterText(q, t, v));
      show(onceNode, accessoriesGross ? fill(t.cart_once, v) : '');
      if (link) {
        label(link, t.cart_cta);
        link.setAttribute('href', (box.dataset.formUrl || '/pages/leasing') + '#konfiguration=' + encode(configuration));
      }
      return;
    }
    show(rateNode, '');
    show(lineNode, q.plan ? t.cart_too_long || '' : q.better ? fill(t.none_missing, v) : t.none || '');
    show(hintNode, '');
    show(onceNode, '');
    if (link) {
      label(link, t.cart_cta_configure);
      /* Ein einzelnes Gerät: im Konfigurator vorwählen (dort lässt sich die Stückzahl erhöhen). */
      const one = devices.length === 1 ? devices[0] : null;
      const params = new URLSearchParams();
      if (one && one.handle) params.set('geraet', one.handle);
      if (one && /^\d+$/.test(String(one.id || ''))) params.set('variante', String(one.id));
      if (one && one.qty > 1) params.set('anzahl', String(one.qty));
      const query = params.toString();
      link.setAttribute('href', fallbackUrl + (query ? (fallbackUrl.indexOf('?') < 0 ? '?' : '&') + query : ''));
    }
  }

  const renderAll = () => {
    document.querySelectorAll('[data-cm-leasing-offer]').forEach((box) => {
      try {
        if (box.dataset.mode === 'cart') renderCart(box);
        else renderProduct(box);
      } catch (error) {
        /* Ohne Rate bleibt der Kasten mit seinem Text und dem Link in den Konfigurator stehen. */
      }
    });
  };
  window.CMLeasing.render = renderAll;

  if (window.cmLeasingOffer) return renderAll();
  window.cmLeasingOffer = true;

  /* Variantenwechsel: den Kasten der neuen Variante aus dem Abschnitt übernehmen, den product-info.js ohnehin lädt
     (wie assets/cm-compliance.js für Energielabel und Herstellerangaben), dann neu rechnen. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const data = event && event.data;
      if (!data || !data.sectionId) return;
      const id = `CmLeasing-${data.sectionId}`;
      const current = document.getElementById(id);
      const next = data.html && data.html.getElementById && data.html.getElementById(id);
      if (current && next) current.innerHTML = next.innerHTML;
      renderAll();
    });
  }
  document.addEventListener('input', (event) => {
    if (event.target && event.target.classList && event.target.classList.contains('quantity__input')) renderAll();
  });
  document.addEventListener('change', (event) => {
    if (event.target && event.target.classList && event.target.classList.contains('quantity__input')) renderAll();
  });
  /* Warenkorbseite: der Kasten steht unter den Knöpfen, außerhalb des Teils, den das Theme nach einer Änderung neu
     zeichnet. Deshalb holt das Skript ihn nach jeder Änderung des Warenkorbs selbst neu — aus demselben Abschnitt
     (Section Rendering, eigener Shop, kein fremder Dienst). Scheitert der Abruf, bleibt der Kasten ohne Rate stehen
     (Text und Link in den Konfigurator), nie mit einer alten. */
  let cartRun = 0;
  const refreshCartSlots = () => {
    const run = ++cartRun;
    document.querySelectorAll('[data-cm-leasing-cart-slot][data-section]').forEach((slot) => {
      const section = slot.dataset.section;
      if (!/^[A-Za-z0-9_-]{1,120}$/.test(section || '') || !slot.id || typeof fetch !== 'function') return;
      slot.querySelectorAll('[data-cm-leasing-rate], [data-cm-leasing-hint], [data-cm-leasing-once]').forEach((node) => show(node, ''));
      fetch(`${window.location.pathname}?section_id=${encodeURIComponent(section)}`, { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.text() : Promise.reject(new Error(String(response.status)))))
        .then((html) => {
          if (run !== cartRun) return;
          const next = new DOMParser().parseFromString(html, 'text/html').getElementById(slot.id);
          if (next) slot.innerHTML = next.innerHTML;
          renderAll();
        })
        .catch(() => undefined);
    });
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartSlots);

  /* Warenkorb und Schublade zeichnet das Theme nach jeder Änderung neu — danach steht der Kasten wieder ohne Rate da. */
  if (typeof MutationObserver === 'function') {
    let frame = 0;
    new MutationObserver((records) => {
      if (frame) return;
      if (!records.some((r) => Array.prototype.some.call(r.addedNodes, (n) => n.nodeType === 1 && (n.matches('[data-cm-leasing-offer]') || n.querySelector('[data-cm-leasing-offer]'))))) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        renderAll();
      });
    }).observe(document.documentElement, { subtree: true, childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderAll);
  else renderAll();
})();
